<template>
	<div v-if="loading" class="u-projects">
		<loader />
	</div>
	<div v-else-if="error">{{ error }}</div>

	<div v-else class="u-projects">
		<div class="u-projects-title-wrapper">
			<h2 class="u-projects-title">
				{{
					options.title
						? options.title
						: `Проекты Фонда - ${nav.NavRecordCount}
            проектов`
				}}
			</h2>
			<a href="/urban/fund/" class="u-projects-all-projects-btn"
				>Все проекты Фонда</a
			>
		</div>
		<div class="u-projects-wrapper">
			<div class="u-projects-card" v-for="card in visibleCards">
				<div class="u-projects-card-wrapper">
					<div class="u-projects-card__img">
						<img
							:src="
								card.props.photo.src && card.props.photo.size > 0
									? card.props.photo.src
									: '/static/v2/src/img/urban/fund/no-img.jpg'
							"
							:alt="card.props.city.value"
						/>
						<div class="u-projects-card__img-title">
							<svg
								width="11"
								height="12"
								viewBox="0 0 11 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle
									cx="5.48079"
									cy="6"
									r="5.33333"
									:fill="setColor(card.props.type.code) || '#82BF00'"
								/>
							</svg>
							<span>{{ card.props.type.value }}</span>
						</div>
					</div>
					<div class="u-projects-card-content">
						<div class="u-projects-card__geo">
							{{ card.props.region.value }}, {{ card.props.city.value }}
						</div>
						<div class="u-projects-card__title">{{ card.name }}</div>
						<a
							:href="card.url"
							:title="card.name"
							target="_blank"
							class="u-projects-card__link"
							>Подробнее
							<svg
								width="13"
								height="10"
								viewBox="0 0 13 10"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M12.2737 5.48011C12.5494 5.21495 12.5494 4.78505 12.2737 4.51989L7.78151 0.198869C7.50585 -0.0662898 7.05891 -0.0662898 6.78324 0.198869C6.50758 0.464029 6.50758 0.893936 6.78324 1.1591L10.0704 4.32102H1.18635C0.796503 4.32102 0.480469 4.62501 0.480469 5C0.480469 5.37499 0.796503 5.67898 1.18635 5.67898H10.0704L6.78324 8.8409C6.50758 9.10606 6.50758 9.53597 6.78324 9.80113C7.05891 10.0663 7.50585 10.0663 7.78151 9.80113L12.2737 5.48011Z"
									fill="white"
								/>
							</svg>
						</a>
					</div>
				</div>
			</div>
		</div>
		<a
			href="/urban/fund/"
			target="_blank"
			class="u-projects-all-projects-btn u-projects-all-projects-btn-m"
			>Все проекты фонда</a
		>
	</div>
</template>

<script>
import Loader from '@/js/vue-components/Loader.vue'

export default {
	name: 'Projects',
	components: { Loader },
	props: {
		options: {
			type: Object,
			default: {},
		},
	},

	data() {
		return {
			colorHint: [
				{ code: 'spatial_development', color: '#82BF00' },
				{ code: 'design_project', color: '#5B90E0' },
			],
			cards: [],
			nav: {},
			loading: true,
			error: null,
			isMobile: false,
		}
	},
	watch: {
		// Здесь можно добавить наблюдатели
		loading(newVal, oldVal) {
			if (!newVal) {
				let element = document.querySelector('.u-projects__loading')
				if (element) {
					element.classList.remove('u-projects__loading')
				}
			}
		},
	},

	beforeCreate() {
		// Вызывается до создания экземпляра компонента
	},

	created() {
		// Вызывается после создания экземпляра компонента
		this.debouncedCheckMobile = this.debounce(this.checkMobile, 250)
	},

	beforeMount() {
		// Вызывается перед монтированием компонента
		window.removeEventListener('resize', this.debouncedCheckMobile)
	},

	mounted() {
		// Вызывается после монтирования компонента
		this.fetchCards()
		this.checkMobile() // Первоначальная проверка
		window.addEventListener('resize', this.debouncedCheckMobile)
	},

	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile)
	},

	computed: {
		// Здесь можно добавить вычисляемые свойства
		visibleCards() {
			if (this.isMobile) {
				return this.cards.slice(0, 2)
			}
			return this.cards
		},
	},
	methods: {
		// Здесь можно добавить методы
		async fetchCards() {
			try {
				const response = await this.axios.get(
					'/api/v2/content/urban/projects/list/?page-size=3'
				)
				this.cards = response.data.data // Получаем первые 3 карточек
				this.nav = response.data.nav
				this.loading = false
			} catch (e) {
				this.error = 'Произошла ошибка при загрузке данных'
				this.loading = false
			}
		},
		debounce(func, wait) {
			let timeout
			return function executedFunction(...args) {
				const later = () => {
					clearTimeout(timeout)
					func(...args)
				}
				clearTimeout(timeout)
				timeout = setTimeout(later, wait)
			}
		},
		setColor(code) {
			return this.colorHint.find(el => el.code === code).color
		},
		checkMobile() {
			this.isMobile = window.innerWidth <= 927 // breakpoint для мобильных устройств
		},
		showAll() {
			this.showAllItems = true
		},
	},
}
</script>
